import { MatButton } from 'components/buttons'
import { Icon } from 'hello-design-system'

const PlayPauseIconButton: React.FC<{
    active: boolean
    disabled: boolean
    onClick: React.MouseEventHandler<HTMLButtonElement>
}> = ({ onClick, disabled, active }) => (
    <MatButton
        id='plus-rounded-icon-button'
        onClick={onClick}
        variant='contained'
        size='small'
        className={'icon-only button-in-active'}
        disabled={disabled}
        width='24px'
        height='24px'
        borderRadius='50%'
        color={'primary'}
    >
        <Icon sx={() => ({ width: '24px' })} iconName={active ? 'PauseCircleRounded' : 'PlayCircleRounded'} />
    </MatButton>
)
export { PlayPauseIconButton }
